"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Aggregate = exports.Unit = void 0;
// eslint-disable-next-line @typescript-eslint/no-redeclare
exports.Unit = {
    Wh: 'Wh',
    kWh: 'kWh',
    MWh: 'MWh',
    GWh: 'GWh',
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
exports.Aggregate = {
    sum: 'sum',
    mean: 'mean',
};
//# sourceMappingURL=originEnergyAPI.schemas.js.map